import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./UploadView.css";
import { _PermittedContent } from "../../_module/utils/PermittedContent";
import { Grid, Divider, Box, AppBar, Tabs, Tab, Chip } from "@material-ui/core";
import clsx from "clsx";
// import { _mlPlaylists, _mlPlaylistsMetadataConfig } from "../../_module/definition/MlPlaylists";
import { _PermittedSetting } from "../../_module/utils/PermittedSetting";
import TextElement from '../preview-element/TextElement';
import moment from "moment";
import { Link } from "react-router-dom";
import { AuthSrc } from './../AuthSrc';
import CliIcon from "images/sky-music.png";
import { DurationDisplayText } from "util/DurationDisplay";



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tabpanel-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

class UploadView extends Component {
    constructor() {
        super();
        this.state = {
            tabValue: 0,
            dirty: false,
            visibleData: true.valueOf,
            artWorkEdit: false,
            messageOpen: false,
            artworkMessageOpen: false,
            externalMessageOpen: false,
            artwork: null,
            prevId: null
        };
    }

    colsDef = null;
    colsDefAll = null;

    generateColsDef(origin) {
        const {
            orgRuntime: {
              runtime: {
                _settingMetadataConditional,
                _settingMetadataFieldsDefault,
                _settingMetadataFieldsCommercial,
                _settingMetadataFieldsLibrary,
                _settingMetadataFieldsCommissioned,
                _mlMetadata, 
                _trackMetadataConfig
              }
            }
          } = this.props;
        this.colsDefAll = [];
        this.colsDef = [];

        const metaDataSetting = _PermittedContent([_mlMetadata, _trackMetadataConfig], []) || { setting: [] };
        this.colsDefAll = this.colsDef =
            _PermittedSetting(metaDataSetting.setting, _settingMetadataFieldsDefault) || []

        if (_PermittedSetting(metaDataSetting.setting, _settingMetadataConditional) || false) {
            if (origin.startsWith("library")) {
                this.colsDef = _PermittedSetting(metaDataSetting.setting,
                    _settingMetadataFieldsLibrary) || this.colsDefAll;
            } else if (origin.startsWith("commercial")) {
                this.colsDef = _PermittedSetting(metaDataSetting.setting,
                    _settingMetadataFieldsCommercial) || this.colsDefAll;
            } else if (origin.startsWith("commissioned")) {
                this.colsDef = _PermittedSetting(metaDataSetting.setting,
                    _settingMetadataFieldsCommissioned) || this.colsDefAll;
            }
        }
    }

    a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    };



    handleTabChange = (event, newValue) => {
        this.setState({ tabValue: newValue });
    };

    canCreatePreRelease = () => {
        const {
            orgRuntime: {
              runtime: {
                _mlContentAdmin,
                _mlContentCanManagePreRelease,
              }
            }
          } = this.props;
        let canArchive = _PermittedContent(
            [_mlContentAdmin, _mlContentCanManagePreRelease],
            []
        )
            ? true
            : false;
        return canArchive;
    };
    canCreateAdminNotes = () => {
        const {
            orgRuntime: {
              runtime: {
                _mlContentAdmin,
                _mlContentCanCreateAdminNotes,
              }
            }
          } = this.props;
        let canArchive = _PermittedContent(
            [_mlContentAdmin, _mlContentCanCreateAdminNotes],
            []
        )
            ? true
            : false;
        return canArchive;
    };





    renderMetadata = (id, i, classes, selectedItem, t, prop) => {
        return prop.tag ? (
            <div key={i} className={classes.trackTags}>
                <label
                    className={
                        id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
                    }
                    title={t(`modules.${id}`)}
                >
                    {t(`modules.${id}`)}
                </label>
                {selectedItem[id] && Array.isArray(selectedItem[id])
                    ? selectedItem[id].map((desc, i) => {
                        return desc ? <Chip key={i} label={desc} /> : null;
                    })
                    : selectedItem[id]
                        ? selectedItem[id]
                        : t("libraryPreview.na")}
            </div>
        ) : (
            <div key={i} className={classes.muDetailWrap}>
                <div
                    className={clsx(
                        id === "title" ? classes.muLabelsBold : classes.muLabels,
                        classes.muLabels
                    )}
                    title={t(`modules.${id}`)}
                >
                    {t(`modules.${id}`)}
                </div>
                <div className={classes.muSeperator}> :</div>
                <div
                    className={clsx(
                        id === "title" ? classes.muDetailsBold : classes.muDetails,
                        classes.muDetails
                    )}
                    title={selectedItem[id] || t("libraryPreview.na")}
                >
                    {selectedItem[id] || t("libraryPreview.na")}
                </div>
            </div>
        );
    };

    getIpsText = (ipsArray) => {
        try {
            if (Array.isArray(ipsArray)) {
                return ipsArray
                    ?.filter((r) => r?.fullName)
                    .map((r) => r?.fullName)
                    ?.join(", ");
            } else {
                return null;
            }
        } catch {
            return null;
        }
    };

    render() {

        const {
            classes,
            data: { selectedItem },
        } = this.props;


        return (

            <Translation>
                {(t, { i18n }) => (
                    <Paper className={clsx(
                        classes.sideBar,
                        classes.uploadPreview
                    )}
                        role="contentinfo">
                        <>
                            {selectedItem ? <>
                                <Paper className={classes.disFlex}>
                                    <h2 className={classes.muTitle}>
                                        {selectedItem.metadata_json?.track_title && selectedItem.metadata_json?.track_title ? selectedItem.metadata_json?.track_title : "" ||
                                            t("libraryPreview.na")}
                                        <span className={classes.muSubTitle}>
                                            {selectedItem.metadata_json && selectedItem.metadata_json?.performers ? selectedItem.metadata_json?.performers.join('/') : ""
                                                || t("libraryPreview.na")}
                                        </span>
                                    </h2>
                                    {/* <DownloadLink track={selectedItem} /> */}
                                </Paper>
                                <Paper>
                                    <Box className={classes.artworkHolder} p={1}>
                                        <Grid
                                            container
                                            direction="column"
                                            alignItems="center"
                                            justify="center"
                                        >
                                            {selectedItem.metadata_json?.artwork_url ? (
                                                <img
                                                    style={{ height: 240, width: 240 }}
                                                    src={
                                                        AuthSrc(selectedItem.metadata_json?.artwork_url)
                                                    }
                                                    alt={selectedItem.metadata_json?.artwork_url || ""}
                                                />
                                            ) : (
                                                <Grid
                                                    container
                                                    direction="column"
                                                    alignItems="center"
                                                    justify="center"
                                                    className={classes.emptyArtwork}
                                                    style={{ height: 240, width: 240 }}
                                                >
                                                     <img className={"emptyArtwork"} style={{ width: 120 }} src={CliIcon}  alt="Sky Music" />
                                                    {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                    <Divider />
                                </Paper>

                                <AppBar className={classes.trackTabsHeader} position="static">
                                    <Tabs
                                        value={this.state.tabValue}
                                        onChange={this.handleTabChange}
                                        scrollButtons="auto"
                                        variant="scrollable"
                                    >
                                        <Tab label="Metadata" {...this.a11yProps(0)} />
                                        <Tab label="Tags" {...this.a11yProps(1)} />
                                        <Tab label="Album Data" {...this.a11yProps(2)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel
                                    className={classes.trackTabs}
                                    value={this.state.tabValue}
                                    index={0}
                                >
                                    <Paper className={classes.paperwrap}>
                                        <div className={classes.muListWrap}>
                                            <TextElement
                                                label="ID"
                                                classes={classes}
                                                data={selectedItem.upload_id}
                                            />
                                            <TextElement
                                                label="DH Track ID"
                                                classes={classes}
                                                data={selectedItem.dh_track_id}
                                            />
                                            <TextElement
                                                label="Title"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.track_title}
                                            />
                                            <TextElement
                                                label="Artist(s)"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.performers?.join(", ")}
                                            />

                                            <TextElement
                                                label="ISRC"
                                                classes={classes}
                                                data={selectedItem.isrc}
                                            />

                                            <TextElement
                                                label="Label"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.rec_label}
                                            />

                                            <TextElement
                                                label="Music Origin"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.musicorigin}
                                            />
                                            {this.canCreatePreRelease() && (
                                                <TextElement
                                                    label="Pre Release"
                                                    classes={classes}
                                                    data={selectedItem.metadata_json?.pre_release ? "Yes" : "No"}
                                                />
                                            )}



                                            <TextElement
                                                label="ISWC"
                                                classes={classes}
                                                data={selectedItem.iswc}
                                            />
                                            <TextElement
                                                label="PRS TUNE CODE"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.prs}
                                            />
                                            <TextElement
                                                label="Arrangers"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.arrangers?.join()}
                                            />
                                            <TextElement
                                                label="Publishers"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.publishers?.join()}
                                            />

                                            <TextElement
                                                label="Composers"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.composers?.join()}
                                            />
                                            <TextElement
                                                label="Lyricists"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.lyricists?.join()}
                                            />
                                            <TextElement
                                                label="P Line"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.pLine}
                                            />
                                            <TextElement
                                                label="Disc No"
                                                classes={classes}
                                                data={selectedItem.disc_no}
                                            />
                                            <TextElement
                                                label="Duration"
                                                classes={classes}
                                                //data={selectedItem.metadata_json?.duration}
                                                data={DurationDisplayText({seconds: selectedItem.duration}) || t("libraryPreview.na")}

                                            />
                                            <TextElement
                                                label="File Name"
                                                classes={classes}
                                                data={selectedItem.file_name}
                                            />
                                            <TextElement
                                                label="Track Position"
                                                classes={classes}
                                                data={selectedItem.position}
                                            />

                                            <TextElement
                                                label="TRANSLATOR"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.translators?.join()}
                                            />
                                            <TextElement
                                                label="BPM"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.bpm}
                                            />
                                            <TextElement
                                                label="TEMPO"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.tempo}
                                            />
                                            <TextElement
                                                label="Track Notes"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.track_notes}
                                            />
                                            {this.canCreateAdminNotes() && (
                                                <TextElement
                                                    label="Admin Notes"
                                                    classes={classes}
                                                    data={selectedItem.metadata_json?.org_admin_notes}
                                                />
                                            )}


                                        </div>
                                    </Paper>
                                </TabPanel>
                                <TabPanel
                                    className={classes.trackTabs}
                                    value={this.state.tabValue}
                                    index={1}
                                >
                                    <Paper className={classes.paperwrap}>
                                        <div className={classes.muListWrap}>
                                            <TextElement
                                                label="GENRE(S)"
                                                classes={classes}
                                                data={ selectedItem.metadata_json?.genres?.map((genre,i) => 
                                                    <Chip key={i} label={genre} />
                                                )}
                                            />
                                            <TextElement
                                                label="STYLE(S)"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.styles?.map((style,i) => 
                                                    <Chip key={i} label={style} />
                                                )}
                                            />
                                            <TextElement
                                                label="MOOD(S)"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.moods?.map((mood,i) => 
                                                    <Chip key={i} label={mood} />
                                                )}
                                            />
                                            <TextElement
                                                label="INSTRUMENT(S)"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.instruments?.map((instrument,i) => 
                                                    <Chip key={i} label={instrument} />
                                                )}
                                            />
                                            <TextElement
                                                label="KEYWORD(S)"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.keywords?.map((keyword,i) => 
                                                    <Chip key={i} label={keyword} />
                                                )}
                                            />
                                            {/* Dont Delete this */}
                                            {/* <TextElement
                                                label="USER TAG(S)"
                                                classes={classes}
                                                data={selectedItem.metadata_json?.org_userTags?.join()}
                                            /> */}
                                            {this.canCreateAdminNotes() && (
                                                <TextElement
                                                    label="TAGS"
                                                    classes={classes}
                                                    data={selectedItem.metadata_json?.org_adminTags?.map((org_adminTag,i) => 
                                                        <Chip key={i} label={org_adminTag} />
                                                    )}
                                                />
                                            )}

                                        </div>

                                    </Paper>
                                </TabPanel>

                                {!selectedItem?.album_metadata ? null : <TabPanel
                                    className={classes.trackTabs}
                                    value={this.state.tabValue}
                                    index={2}
                                >
                                    <Paper className={classes.paperwrap}>
                                        <div className={classes.muListWrap}>

                                            <TextElement
                                                label="ID"
                                                classes={classes}
                                                data={selectedItem.album_upload_id ? selectedItem.album_upload_id : selectedItem.dh_album_metadata?.id}
                                            />
                                            <TextElement
                                                label="DH Album ID"
                                                classes={classes}
                                                data={selectedItem.album_metadata ? selectedItem.album_metadata?.dh_album_id : selectedItem.dh_album_metadata?.id}
                                            />
                                            <TextElement
                                                label="Album Title"
                                                classes={classes}
                                                data={<Link
                                                    style={{ textDecoration: "none", color: "#fff" }}
                                                    key={selectedItem.album_metadata?.dh_album_id}
                                                    to={`/uploads/albums/${selectedItem.album_metadata?.dh_album_id}`}
                                                >
                                                    <strong class="tablesLink">
                                                        {selectedItem?.album_metadata?.album_title}
                                                    </strong>
                                                </Link>}
                                            />
                                            <TextElement
                                                label="Album artist"
                                                classes={classes}
                                                data={selectedItem.album_metadata?.album_artist}
                                            />
                                            <TextElement
                                                label="Catalog #"
                                                classes={classes}
                                                data={selectedItem.album_metadata?.catalogue_number}
                                            />
                                            <TextElement
                                                label="UPC"
                                                classes={classes}
                                                data={selectedItem.album_metadata?.upc}
                                            />
                                            <TextElement
                                                label="Release Date"
                                                classes={classes}
                                                data={selectedItem.album_metadata?.album_release_date}
                                            />
                                            <TextElement
                                                label="Album Notes"
                                                classes={classes}
                                                data={selectedItem.album_metadata?.album_notes}
                                            />
                                            {/* Dont Delete this */}
                                            {/* <TextElement
                                                label="User Tags"
                                                classes={classes}
                                                data={selectedItem.album_metadata?.org_album_userTags?.join()}
                                            />   */}
                                            {this.canCreateAdminNotes() && (
                                                <TextElement
                                                    label="Tags"
                                                    classes={classes}
                                                    data={selectedItem.album_metadata?.org_album_adminTags?.join()}
                                                />
                                            )}
                                            {this.canCreateAdminNotes() && (
                                                <TextElement
                                                    label="Admin Notes"
                                                    classes={classes}
                                                    data={selectedItem.album_metadata?.org_album_admin_notes}
                                                />
                                            )}
                                        </div>
                                    </Paper>
                                </TabPanel>}
                            </> :
                                <div className={classes.noData}>
                                    Nothing to preview
                                </div>
                            }
                        </>
                    </Paper>
                )}
            </Translation>
        );
    }
}

const mapStateToProps = (state) => ({
    data: state.mlTrackUpdateReducer,
    externalData: state.smContentTrackReducer,
    orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
})(withStyles(styles)(UploadView));
